import { memo } from 'react';

import DefineDocumentUploadView from './define-document-upload.view';

const DefineDocumentUpload = () => {
	return <DefineDocumentUploadView />;
};

export default memo(DefineDocumentUpload);
